import Accordion from '@/common/components/Accordion'
import UpdateEstablishmentDisplayAndSalesRestrictionModal from './UpdateDisplayAndSalesRestrictionModal';
import Select from '@/common/components/Select';
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type';
import { useMemo } from 'react';
import {  EstablishmentAllowedClientCompanyData } from '../../types/establishmentAllowedClientCompanies.type';
import { EstablishmentAllowedClientCompaniesTransformer } from '../../services/establishmentAllowedClientCompaniesTransformer';

interface DisplayAndSalesRestrictionAccordionProps {
  establishmentCompany?: EstablishmentCompanyData;
  establishmentAllowedClientCompanies?: EstablishmentAllowedClientCompanyData[]
  establishmentAllowedClientCompaniesIsRefetching?: boolean
  establishmentAllowedClientCompaniesIsFetched?: boolean
  disabled?: boolean;
}

export default function DisplayAndSalesRestrictionAccordion({ 
  establishmentCompany, 
  establishmentAllowedClientCompanies, 
  establishmentAllowedClientCompaniesIsRefetching, 
  establishmentAllowedClientCompaniesIsFetched,
  disabled 
}: DisplayAndSalesRestrictionAccordionProps) {    
  const establishmentAllowedClientCompaniesOptions = useMemo(() => {
    if (!establishmentAllowedClientCompanies) return undefined;
    
    return EstablishmentAllowedClientCompaniesTransformer.optionsTransformer()(establishmentAllowedClientCompanies as any)
  }, [establishmentAllowedClientCompaniesIsRefetching, establishmentAllowedClientCompaniesIsFetched]);

  return (
    <Accordion
      name="displayAndSalesRestriction"
      head={(
        <div className="flex items-center gap-3">
          <div className='flex items-center gap-3'>
            <div onClick={(event) => {
              event.stopPropagation();
            }}>
              <UpdateEstablishmentDisplayAndSalesRestrictionModal
                establishmentCompany={establishmentCompany}
                establishmentAllowedClientCompanies={establishmentAllowedClientCompanies}
                establishmentAllowedClientCompaniesOptions={establishmentAllowedClientCompaniesOptions}
                disabled={disabled}
              />
            </div>

            <div className="flex flex-col gap-2">
              <h2 className='text-left'>Restrição de Exibição e Vendas</h2>

              <p className="text-[14px] font-light italic">
                (Exibir e permitir vendas somente para empresas selecionadas)
              </p>
            </div>
          </div>
        </div>
      )}
      body={(
        <div>
          <Select
            isMulti
            label='Empresas permitidas'
            value={establishmentAllowedClientCompaniesOptions}
            isDisabled
          />
        </div>
      )}
    />
  )
}